import React from 'react';
import { Box, ScrollArea } from '@mantine/core';
import RightPanelHeader from './RightPanelHeader';
import SelectedFilterContent, { type SelectedFilterContentProps } from './SelectedFilterContent';

export interface RightPanelProps extends SelectedFilterContentProps {
  handleRemoveFilter: (filterName: string) => void;
  hasChildActiveFilters: () => boolean;
  selectedCategoryType?: 'idea' | 'evidence' | null;
}

const RightPanel: React.FC<RightPanelProps> = ({
  selectedChildFilter,
  selectedCategory,
  selectedCategoryType,
  handleRemoveFilter,
  hasChildActiveFilters,
  filtersConfig,
  localActiveFilters,
  setLocalActiveFilters,
  getFilterKey,
  setFetchableCheckboxCounts,
  clearTrigger,
}) => {
  return (
    <Box className="filter-modal-right-panel" >
      <Box
        pl="md"
        pt="md"
        pb='lg'
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <RightPanelHeader
            filtersConfig={filtersConfig}
            selectedCategory={selectedCategory}
            selectedChildFilter={selectedChildFilter}
            localActiveFilters={localActiveFilters}
            handleRemoveFilter={handleRemoveFilter}
            hasChildActiveFilters={hasChildActiveFilters}
          />
        </Box>
        <ScrollArea
          type="scroll"
          scrollbarSize={8}
          sx={{
            flex: 1,
            minHeight: 0,
          }}
        >
          <SelectedFilterContent
            selectedCategory={selectedCategory}
            selectedChildFilter={selectedChildFilter}
            selectedCategoryType={selectedCategoryType}
            filtersConfig={filtersConfig}
            localActiveFilters={localActiveFilters}
            setLocalActiveFilters={setLocalActiveFilters}
            getFilterKey={getFilterKey}
            setFetchableCheckboxCounts={setFetchableCheckboxCounts}
            clearTrigger={clearTrigger}
          />
        </ScrollArea>
      </Box>
    </Box>
  );
};

export default RightPanel;
